<template>
  <AsteonlineCard v-if="!showIfBookmarked || (showIfBookmarked && isBookmarked)">
    <CardHead>
      &nbsp;
      <LotBadge
        :lot="lot"
        :my-lot="myLot"
        :is-outbid="isOutbid"
        :is-redistribute="true"
      />

      <div class="float-right">
        <BookmarkIcon
          :lot="lot"
          :is-bookmarked="isBookmarked"
          @added="isBookmarked = true"
          @removed="isBookmarked = false"
        />
      </div>
    </CardHead>

    <CardBody>
      <LotRecapRedistribute
        :lot="lot"
        :product-map="productMap"  
        :in-modal="false"
      />

      <div
        class="mt-2 "
      >
        <div
          v-if="auction.auctionStatus == 'REDISTRIBUTING_1' || auction.auctionStatus == 'REDISTRIBUTING_2'"
          class="w-1/2 md:w-1/3 lg:w-1/4 mx-auto"
        >
          <PreemptButton
            v-if="authStore.canBid && myLot.canSelect"
            :auction="auction"
            :lot="lot"
            :my-lot="myLot"
            @click.prevent="preemptingLot = lot"
          />
        </div>
      </div>
    </CardBody>
  </AsteonlineCard>

  <PreemptModal
    v-if="preemptingLot"
    :auction="auction"
    :product-map="productMap"
    :lot="preemptingLot"
    @close="preemptingLot = null"
    @update-auction="$emit('update-auction', $event)"
  />
</template>

<script setup>
import { ref } from 'vue'

import AsteonlineCard from '@/components/card/AsteonlineCard.vue';
import CardBody from '@/components/card/CardBody.vue';
import CardHead from '@/components/card/CardHead.vue';
import BookmarkIcon from '@/components/lot/BookmarkIcon.vue';
import LotBadge from '@/components/lot/LotBadge.vue';
import PreemptButton from '@/components/lot/PreemptButton.vue';
import lotBookmark from '@/services/lot-bookmarks';
import { useAuthStore } from '@/stores/auth';

import LotRecapRedistribute from './LotRecapRedistribute.vue';
import PreemptModal from './PreemptModal.vue';

const authStore = useAuthStore()

const emit = defineEmits(['update-auction'])

const props = defineProps({
    auction: {
        type: Object,
        required: true
    },
    lot: {
        type: Object,
        required: true
    },
    myLot: {
        type: Object,
        required: false,
        default: null
    },
    productMap: {
        type: Object,
        required: true
    },
    showIfBookmarked: {
        type: Boolean,
        required: true
    },
    isOutbid: {
        type: Boolean,
        required: false
    }
})

const isBookmarked = ref(lotBookmark.isBookmarked(props.lot.uuid));

const preemptingLot = ref(null)

</script>